import React, {useEffect, useState} from 'react';
import {BrowseLabel, Headline, Label, TextWrapper, UploadImageWrapper} from './UploadImageComponent.style';
import {DragAndDrop} from '../DragAndDrop/DragAndDrop';
import {Button} from '@bosch/react-frok';
import {t} from 'i18next';
import {config} from '../../init/config';
import {Valid} from '../validation/Valid';
import {validateThumbnailImage} from '../../utils';

export interface UploadImageComponentProps {
    readonly existingImage: File | null;
    onChange: (imageFile: File | null) => void;
}

/**
 * @name UploadImageComponent
 * @description
 * A component to select an image to upload with preview functionality
 */
export const UploadImageComponent = (props: UploadImageComponentProps) => {
    const [image, setImage] = useState<File | null>(null);

    useEffect(() => {
        setImage(props.existingImage);
    }, [props.existingImage]);

    const handleImageFile = (imageFile: File | null) => {
        setImage(imageFile);
        props.onChange(imageFile);
    };

    const handleDelete = () => {
        setImage(null);
        props.onChange(null);
    };

    return (
        <Valid
            isValid={validateThumbnailImage(image)}
            message={t('UPLOAD_IMAGE_SIZE_ERROR', {size: config.DLS_THUMBNAIL_MAX_SIZE})}>
            <UploadImageWrapper>
                {(!image) &&
                <TextWrapper>{t('UPLOAD_IMAGE_SIZE_INFO', {size: config.DLS_THUMBNAIL_MAX_SIZE})}</TextWrapper>
                }
                <Headline>
                    {(!image) ? (
                        <div>
                            <input
                                type='file'
                                accept='image/*'
                                id='select-file'
                                style={{display: 'none'}}
                                onChange={(e) => (e.target.files ? handleImageFile(e.target.files[0]) : null)}
                            />
                            <Label htmlFor={'select-file'}>
                                <BrowseLabel className='a-button a-button--secondary'>
                                    <i className='a-icon a-button__icon boschicon-bosch-ic-folder-add'/>
                                    <div className='a-button__label'>{t('UPLOAD_IMAGE_BROWSE')}</div>
                                </BrowseLabel>
                            </Label>
                        </div>
                    ) : (
                        <Button key='delete' icon='delete' mode='tertiary' type='button' onClick={handleDelete}/>
                    )}
                </Headline>
                {image ? (
                    <img style={{maxWidth: '100%', maxHeight: '100%'}}
                         src={URL.createObjectURL(image)} alt='Thumb'/>
                ) : (
                    <DragAndDrop browseFile={image}
                                 acceptImagesOnly={true}
                                 onChange={handleImageFile}
                    />
                )}
            </UploadImageWrapper>
        </Valid>
    );
};
